import FoodBankIcon from '@mui/icons-material/FoodBank';
import InventoryIcon from '@mui/icons-material/Inventory';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import SvgIcon from '@mui/material/SvgIcon';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { ReactComponent as CustomReportIcon } from '../../../../../assets/customReportsIcon.svg';
import {
  customReportsSx,
  iconSx,
  inventoryReportSx,
  kitchenReportSx,
  laborReportsSx,
  mediumSx,
  menuReportsSx,
  salesReportSx,
  smallSx,
} from './styles';

type ReportIconsProps = {
  sectionHeader: string;
  size?: 'small' | 'medium';
};

export default function ReportIcons({ sectionHeader, size = 'medium' }: ReportIconsProps) {
  const { t } = useTranslation();
  const sizeSx = size === 'small' ? smallSx : mediumSx;
  function getIconForSection(header: string): JSX.Element | null {
    switch (header) {
      case t('admin.centralReportsPage.sectionHeaders.laborReports'):
        return (
          <Box sx={{ ...laborReportsSx, ...sizeSx }}>
            <PeopleAltIcon
              sx={iconSx}
              aria-label={`${t('admin.centralReportsPage.sectionHeaders.laborReports')} Icon`}
            />
          </Box>
        );
      case t('admin.centralReportsPage.sectionHeaders.inventoryReports'):
        return (
          <Box sx={{ ...inventoryReportSx, ...sizeSx }}>
            <InventoryIcon
              sx={iconSx}
              aria-label={`${t('admin.centralReportsPage.sectionHeaders.inventoryReports')} Icon`}
            />
          </Box>
        );
      case t('admin.centralReportsPage.sectionHeaders.salesReports'):
        return (
          <Box sx={{ ...salesReportSx, ...sizeSx }}>
            <MonetizationOnIcon
              sx={iconSx}
              aria-label={`${t('admin.centralReportsPage.sectionHeaders.salesReports')} Icon`}
            />
          </Box>
        );
      case t('admin.centralReportsPage.sectionHeaders.kitchenReports'):
        return (
          <Box sx={{ ...kitchenReportSx, ...sizeSx }}>
            <FoodBankIcon
              sx={iconSx}
              aria-label={`${t('admin.centralReportsPage.sectionHeaders.kitchenReports')} Icon`}
            />
          </Box>
        );
      case t('admin.centralReportsPage.sectionHeaders.menuReports'):
        return (
          <Box sx={{ ...menuReportsSx, ...sizeSx }}>
            <RestaurantMenuIcon
              sx={iconSx}
              aria-label={`${t('admin.centralReportsPage.sectionHeaders.menuReports')} Icon`}
            />
          </Box>
        );
      case t('admin.centralReportsPage.sectionHeaders.customReports'):
        return (
          <Box sx={{ ...customReportsSx, ...sizeSx }}>
            <SvgIcon
              viewBox='0 0 20 20'
              component={CustomReportIcon}
              sx={iconSx}
              aria-label={`${t('admin.centralReportsPage.sectionHeaders.customReports')} Icon`}
            />
          </Box>
        );
      default:
        return null;
    }
  }

  return getIconForSection(sectionHeader);
}
